import React from 'react';
import {Auth} from "../../modules/auth/Auth";
import i18n from "../../core/i18n";

const LanguageSelect = (): React.ReactElement => {
    const langPairs = [
        {key: 'PL', value: 'pl'},
        {key: 'ENG', value: 'en'}
    ];

    const changeLanguage = (value: string): void => {
        i18n.changeLanguage(value);
        i18n.reloadResources(value)
    }

    return (
        <div>
            {langPairs.map((el, index) => {
                return <span key={el.key}>
                    <span>{index > 0 ? ' | ' : ''}</span>
                    <button style={{background: 'none', border: 'none', cursor: 'pointer'}}
                            onClick={(): void => {
                                changeLanguage(el.value)
                            }}>{el.key}
                    </button>
                </span>
            })}
        </div>
    );
};

export default LanguageSelect;
